export default __webpack_public_path__ + "static/media/undraw_server_down_s4lk.532ea75d.svg";